import {
  useToolTipEffect,
  ToolTipProps,
  ToolTipTemplateProps,
  ToolTipBasicTemplate,
  ToolTipDefaultTemplate,
} from '../../..';

export const ToolTipElement = (props: ToolTipProps) => {
  const [state] = useToolTipEffect(props);

  const templateProps: ToolTipTemplateProps = {
    ...state,
  };

  let template;
  switch (props.template) {
    case 'toolTipBasic':
      template = ToolTipBasicTemplate(templateProps);
      break;
    case 'toolTipDefault':
    default:
      template = ToolTipDefaultTemplate(templateProps);
      break;
  }

  return template;
};
